import {
  ApproveWeekRequest,
  EmailReportRequest,
  EntryFull,
  EntryListItem,
  EntryPatchRequest,
  ReportEmailStatus,
  ResolveConflictRequest,
} from '@siteday/shared';
import { z } from 'zod';

import { api, buildUrl } from './client';
import { listOf } from './list';

export type EntriesFilters = {
  jobId?: string | undefined;
  foremanId?: string | undefined;
  from?: string | undefined;
  to?: string | undefined;
  status?: string | undefined;
  limit?: number | undefined;
};

export const listEntries = (filters: EntriesFilters = {}) =>
  api.get('/entries', listOf(EntryListItem), {
    jobId: filters.jobId,
    foremanId: filters.foremanId,
    from: filters.from,
    to: filters.to,
    status: filters.status,
    limit: filters.limit ?? 200,
  });

export const getEntry = (id: string) => api.get(`/entries/${id}`, EntryFull);

export const patchEntry = (id: string, body: z.input<typeof EntryPatchRequest>) =>
  api.patch(`/entries/${id}`, EntryPatchRequest.parse(body), EntryFull);

export const approveEntry = (id: string) =>
  api.post(`/entries/${id}/approve`, undefined, EntryFull);
export const unapproveEntry = (id: string) =>
  api.post(`/entries/${id}/unapprove`, undefined, EntryFull);

export const approveWeek = (jobId: string, weekStart: string) =>
  api.post(
    '/entries/approve-week',
    ApproveWeekRequest.parse({ jobId, weekStart }),
    z.object({ approved: z.number().int() }).passthrough(),
  );

export const resolveConflict = (id: string, body: z.input<typeof ResolveConflictRequest>) =>
  api.post(`/entries/${id}/resolve-conflict`, ResolveConflictRequest.parse(body), EntryFull);

export const emailReport = (id: string, to: string[]) =>
  api.post(`/entries/${id}/email`, EmailReportRequest.parse({ to }), ReportEmailStatus);

/** GET /entries/:id/report.pdf — a link, not a JSON call (cookie auth follows the browser). */
export const reportPdfUrl = (id: string) => buildUrl(`/entries/${id}/report.pdf`);
